import React from 'react';
import { connect } from 'react-redux';

class PopupCustomized extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(event) {
        const
            {
                close
            } = this.props;

        if (this.wrapperRef) {
            if (!this.wrapperRef.current.contains(event.target)) {
                close();
            }
        }
    }

    render() {
        const
            {
                Message,
                x, y
            } = this.props;

        const maxWidth = 500;
        const yOffset = `${y}px`;
        let xOffset = `${x}px`;
        if (window.innerWidth < x + maxWidth) {
            xOffset = `${window.innerWidth - maxWidth}px`;
        }
        
        return (<div className="modal displayBlock" >
            <div className="modal-content" ref={this.wrapperRef}
                style={{
                    padding: '20px',
                    borderRadius: '12px',
                    width: 'fit-content',
                    margin: '0',
                    position: 'fixed',
                    top: yOffset,
                    left: xOffset,
                    maxWidth: maxWidth + 'px'
                }}>
                <div>
                    {Message}
                </div>
            </div>
        </div>);
    }
};

const select = state => ({ ...state.session });
export default connect(select)(PopupCustomized);

